import {serializable} from 'serializr';

export interface ISmsErrorMessage {
    Message: string;
    Level?: string;
}

export interface ISmsStatusDetails {
    customError?: string;
    smsError?: ISmsErrorMessage;
    statusMessage?: string;
}

export class SendSmsStatus {
    @serializable name: string;

    @serializable isActive: boolean;

    messageDetails: ISmsStatusDetails;

    constructor(name: string = '', isActive: boolean = false, messageDetails: ISmsStatusDetails = {}) {
        this.name = name;
        this.isActive = isActive;
        this.messageDetails = messageDetails;
    }
}
